define('app/factories/travel_hotel_factory',['app/setup', 'app/views/travel_hotel_details_view', 'app/views/travel_hotel_offline_checkout_view'],
  function (takhfifan, checkout) {
    $('.tkh-travel-hotel-offline-checkout').each(function () {
      new takhfifan.hotelOfflineCheckout({
        el: $(this)
      });
    });

    $('.tkh-travel-hotel_detail_wrapper').each(function(){
      new takhfifan.travelHotelDetailsView({
        el: $(this)
      });
    });

    $('.tkh-travel-checkout').each(function(){
      new takhfifan.travelCheckout({
        el: $(this)
      });
    });
});



